import { HLX_CALENDAR_EVENTS_ROUTES } from '~/features/market/calendar/routes';
import {
  MARKET_CONTRACT_DETAIL_ROUTES,
  MARKET_CONTRACT_LIST_ROUTES,
  MARKET_CONTRACT_SIGN_ROUTES,
  MARKET_CONTRACT_SUMMARY_ROUTES,
  MARKET_CONTRACT_TERMINATE_ROUTES,
  MARKET_CONTRACT_WITHDRAW_TERMINATION_ROUTES,
} from '~/features/market/contracts/routes';
import { EMPLOYER_FACILITY_ROUTES } from '~/features/market/facility/routes';
import {
  MSAAS_DETAIL_CALCULATIONS_ROUTES,
  MSAAS_DETAIL_SUMMARY_ROUTES,
  MSAAS_FACILITIES_ROUTES,
  MSAAS_GEOGRAPHIES_ROUTES,
  MSAAS_LISTING_ACTIVATE_ROUTES,
  MSAAS_LISTING_CANCEL_ROUTES,
  MSAAS_LISTING_DEACTIVATE_ROUTES,
  MSAAS_LISTING_RELIST_ROUTES,
  MSAAS_LISTING_ROUTES,
  MSAAS_PROVIDERS_ROUTES,
  MSAAS_STATES_ROUTES,
} from '~/features/market/listings/msaas-listing/routes';
import {
  SERVICE_OPPORTUNITIES_ROUTES,
  SERVICE_OPPORTUNITY_COUNTER_AVAILABILITY_ROUTES,
  SERVICE_OPPORTUNITY_COUNTER_ROUTES,
  SERVICE_OPPORTUNITY_ROUTES,
} from '~/features/market/service-opportunities/routes';
import { JOB_MESSAGES_READ_ROUTES } from '~/features/provider-hlx/job-opportunities/routes';
import { CERT_ROUTES } from '~/features/vault/certification/api';

import {
  JOB_RESPONSE_BEGIN_NEGOTIATION_ROUTES,
  JOB_RESPONSE_INITIAL_MESSAGE_ROUTES,
  JOB_RESPONSE_ROUTES,
  MSAAS_LISTING_FIT_CHECK_ROUTES,
  MSAAS_LISTING_SEARCH_ROUTES,
} from '~/features/market/listing-search/routes';
import { AOI_OPTIONS_ROUTES_BY_PROVIDER_CATEGORY } from '~/features/market/listings/routes';
import { PEER_REFERENCE_ROUTES } from '~/features/peerReference/routes';
import {
  EDUCATION_DETAILS_ROUTES,
  EDUCATION_ROUTES,
  INSTITUTIONS_ROUTES,
  TRAINING_ROUTES,
} from '~/features/vault/academics/routes';
import { AOI_OPTIONS_ROUTES, AOI_ROUTES, AOI_SPEC_ROUTES } from '~/features/vault/aoi/api';
import {
  ATTESTATIONS_ROUTES,
  ATTESTATION_FORM_ROUTES,
  ATTESTATION_ROUTE,
} from '~/features/vault/attestations/api';
import { BOARD_CERT_ROUTES } from '~/features/vault/board-certification/api';
import { CME_TRAINING_ROUTES } from '~/features/vault/cme-training/api';
import {
  AI_JOBS_ROUTES,
  DOCUMENTS_ROUTES,
  DOCUMENT_CV_UPLOAD_ROUTES,
  DOCUMENT_DOWNLOAD_ROUTES,
} from '~/features/vault/documents/api';
import { EMPLOYMENT_ROUTES } from '~/features/vault/employment/api';
import { FACILITY_ROUTES } from '~/features/vault/facility/constants';
import { CDS_LICENSES_API_ROUTES, DEA_LICENSES_API_ROUTES } from '~/features/vault/licenses/routes';
import { CLAIMS_ROUTES } from '~/features/vault/malpractice/claims/api';
import { INSURANCE_ROUTES } from '~/features/vault/malpractice/insurance/api';
import {
  MEDICAL_LICENSES_ROUTES,
  MEDICAL_LICENSE_TYPES_ROUTE,
} from '~/features/vault/medical-license/api';
import {
  PEER_REFERENCE_REQ_RESEND_ROUTES,
  PEER_REFERENCE_REQ_ROUTES,
  PROVIDER_PEER_REFERENCE_ROUTES,
} from '~/features/vault/peer-reference-request/api';

import { MEDICAL_BOARD_ROUTES } from '~/api/medicalBoard/constants';
import { SPECIALTY_ROUTES } from '~/api/specialty/constants';
import { SPECIALTY_BOARD_ROUTES } from '~/api/specialtyBoard/constants';
import {
  SPECIALTY_CERT_BY_SPECIALTY_ROUTES,
  SPECIALTY_CERT_ROUTES,
} from '~/api/specialtyCertificate/constants';
import {
  SUB_SPECIALTY_CERTIFICATE_ROUTES,
  SUB_SPECIALTY_CERT_BY_PARENT_ROUTES,
} from '~/api/subSpecialtyCertificate/constants';
import { BILLING_ROUTES } from '~/features/employer/billing/routes';
import {
  EMPLOYER_USER_FROM_INVITATION_ROUTES,
  EMPLOYER_USER_INVITATIONS_FOR_EMPLOYER_ROUTES,
  EMPLOYER_USER_INVITATION_ELIGIBILITY_ROUTES,
  EMPLOYER_USER_INVITATION_RESEND_ROUTES,
  EMPLOYER_USER_INVITATION_VERIFY_ROUTES,
} from '~/features/employer/colleague-invites/routes';
import {
  PROVIDER_ASSOCIATION_ACCEPT_ROUTES,
  PROVIDER_ASSOCIATION_ADD_MANAGED_ROUTES,
  PROVIDER_ASSOCIATION_CURRENT_ROUTES,
  PROVIDER_ASSOCIATION_DISASSOCIATE_ROUTES,
  PROVIDER_ASSOCIATION_HISTORY_ROUTES,
  PROVIDER_ASSOCIATION_INVITATIONS_ROUTES,
  PROVIDER_ASSOCIATION_INVITATION_RESEND_ROUTES,
  PROVIDER_ASSOCIATION_INVITE_MANAGED_ROUTES,
  PROVIDER_ASSOCIATION_INVITE_ROUTES,
  PROVIDER_ASSOCIATION_LOOKUP_BY_NPI_ROUTES,
  PROVIDER_ASSOCIATION_PROVIDER_HISTORY_ROUTES,
  PROVIDER_ASSOCIATION_RECIPIENT_ROUTES,
  PROVIDER_ASSOCIATION_ROUTES,
  PROVIDER_ASSOCIATION_VERIFY_ROUTES,
} from '~/features/employer/provider-associations/routes';
import { PROVIDER_SERVICE_LISTING_SEARCH_ROUTES } from '~/features/employer/provider-search/routes';
import {
  HLX_ACCEPT_LISTING_ROUTES,
  HLX_ACCEPT_ROUTES,
  HLX_JOB_RESPONSE_UNMASK_APPROVE_ROUTES,
  HLX_JOB_RESPONSE_UNMASK_REJECT_ROUTES,
  HLX_JOB_RESPONSE_UNMASK_REQUEST_ROUTES,
  HLX_JOB_RESPONSE_UNMASK_STATE_ROUTES,
  HLX_JOB_RESPONSE_UNMASK_WITHDRAW_ROUTES,
  HLX_PROVIDER_VIEW_BY_RESPONSE_PROVIDER_ROUTES,
  HLX_PROVIDER_VIEW_BY_SERVICE_LISTING_ROUTES,
  HLX_PROVIDER_VIEW_ROUTES,
  HLX_UNMASK_APPROVE_ROUTES,
  HLX_UNMASK_REJECT_ROUTES,
  HLX_UNMASK_REQUEST_ROUTES,
} from '~/features/employer/provider-view/routes';
import { FEATURE_FLAG_ROUTES } from '~/features/feature-flags/routes';
import {
  B2B_JOB_OPPORTUNITIES_ROUTES,
  B2B_LISTING_RESPONSES_ROUTES,
  HLX_PICKER_PROVIDERS_ROUTES,
  JOB_RESPONSE_PROVIDERS_ROUTES,
} from '~/features/market/job-opportunities/routes';
import {
  JOB_NEGOTIATION_BY_RESPONSE_ROUTES,
  JOB_RESPONSE_VIEWED_ROUTES,
  PROVIDER_JOB_RESPONSES_ROUTES,
} from '~/features/market/job-responses/provider-responses/routes';
import {
  JOB_LISTING_ACTIVATE_ROUTES,
  JOB_LISTING_ACTIVE_ROUTES,
  JOB_LISTING_CALCULATIONS_ROUTES,
  JOB_LISTING_DEACTIVATE_ROUTES,
  JOB_LISTING_DETAILS_ROUTES,
  JOB_LISTING_FACILITIES_ROUTES,
  JOB_LISTING_MARKETPLACE_SEARCH_ROUTES,
  JOB_LISTING_ROUTES,
  JOB_LISTING_STATES_ROUTES,
  JOB_LISTING_SUMMARY_ROUTES,
} from '~/features/market/listings/job-listing/routes';
import { MSAAS_DETAILS_ROUTES } from '~/features/market/listings/msaas-listing/routes';
import {
  JOB_NEGOTIATIONS_ROUTES,
  JOB_NEGOTIATION_CALCULATIONS_ROUTES,
  JOB_RESPONSE_INITIAL_NEGOTIATION_ROUTES,
  JOB_RESPONSE_NEGOTIATION_DRAFT_ROUTES,
  MSAAS_NEGOTIATIONS_BY_EMPLOYER_ROUTES,
  MSAAS_NEGOTIATION_BY_RESPONSE_ROUTES,
  MSAAS_NEGOTIATION_CALCULATIONS_ROUTES,
  MSAAS_NEGOTIATION_CONTRACT_SUMMARY_ROUTES,
  MSAAS_NEGOTIATION_SHIFT_BREAKDOWN_ROUTES,
  NEGOTIATIONS_ROUTES,
  NEGOTIATION_ROUTES,
} from '~/features/market/negotiations/routes';
import { EMPLOYER_INFO_CURRENT_ROUTES } from '~/features/market/organization/employer-info/routes';
import {
  PROVIDER_CALENDAR_BATCH_REPLACE_ROUTES,
  PROVIDER_CALENDAR_BULK_ROUTES,
  PROVIDER_CALENDAR_CONTRACTS_ROUTES,
  PROVIDER_CALENDAR_DAY_ROUTES,
  PROVIDER_CALENDAR_ROUTES,
  PROVIDER_CALENDAR_RULES_ROUTES,
  PROVIDER_CALENDAR_RULE_EXCEPTION_ROUTES,
  PROVIDER_CALENDAR_RULE_ROUTES,
} from '~/features/provider-hlx/calendar/routes';
import {
  JOB_MESSAGES_ROUTES,
  JOB_OPPORTUNITIES_ROUTES,
  JOB_OPPORTUNITY_STATUS_ROUTES,
} from '~/features/provider-hlx/job-opportunities/routes';
import {
  GEOGRAPHY_SEARCH_ROUTES,
  PROVIDER_SERVICE_LICENSE_STATE_SUGGESTIONS_ROUTES,
  PROVIDER_SERVICE_LISTING_ACTIVATE_ROUTES,
  PROVIDER_SERVICE_LISTING_ARCHIVE_ROUTES,
  PROVIDER_SERVICE_LISTING_DETAIL_ROUTES,
  PROVIDER_SERVICE_LISTING_PAUSE_ROUTES,
  PROVIDER_SERVICE_LISTING_ROUTES,
} from '~/features/provider-hlx/service-listings/routes';
import { TERMS_ROUTES } from '~/features/terms/routes';
import { EMPLOYER_USER_ROUTES, PROVIDER_ROUTES, USER_ROUTES } from '~/features/user/api';
import { VAULT_NEW_RECORDS_ROUTES } from '~/features/vault/newRecords/api';
import {
  AVAILABLE_PRIVILEGES_ROUTES,
  BULK_PRIVILEGES_ROUTES,
  EXPORT_PRIVILEGES_ROUTES,
  PRIVILEGES_ROUTES,
} from '~/features/vault/privileges/api';
import {
  ALL_PROVIDER_TYPES_ROUTE,
  PROVIDER_CATEGORIES_ROUTE,
  PROVIDER_DETAILS_ROUTE,
  PROVIDER_TYPES_ROUTE,
} from '~/features/vault/profile/routes';
import { PROFILE_SUGGESTIONS_ROUTES } from '~/features/vault/profileSuggestions/api';
import { NOTIFICATION_READ_ALL_ROUTES, NOTIFICATION_ROUTES } from '~/services/notifications/api';

export const ROUTES = {
  featureFlags: FEATURE_FLAG_ROUTES,
  terms: TERMS_ROUTES,
  attestation_forms: ATTESTATION_FORM_ROUTES,
  attestations: ATTESTATIONS_ROUTES,
  attestation: ATTESTATION_ROUTE,
  aois: AOI_ROUTES,
  aoisOptions: AOI_OPTIONS_ROUTES,
  aoisOptionsByProviderCategory: AOI_OPTIONS_ROUTES_BY_PROVIDER_CATEGORY,
  aoisSpec: AOI_SPEC_ROUTES,
  aiJobs: AI_JOBS_ROUTES,
  availablePrivileges: AVAILABLE_PRIVILEGES_ROUTES,
  boardCertification: BOARD_CERT_ROUTES,
  certifications: CERT_ROUTES,
  cdsLicenses: CDS_LICENSES_API_ROUTES,
  claims: CLAIMS_ROUTES,
  cvParse: DOCUMENT_CV_UPLOAD_ROUTES,
  cmeTraining: CME_TRAINING_ROUTES,
  deaLicenses: DEA_LICENSES_API_ROUTES,
  documentDownload: DOCUMENT_DOWNLOAD_ROUTES,
  documents: DOCUMENTS_ROUTES,
  marketContractList: MARKET_CONTRACT_LIST_ROUTES,
  marketContractDetail: MARKET_CONTRACT_DETAIL_ROUTES,
  marketContractSummary: MARKET_CONTRACT_SUMMARY_ROUTES,
  marketContractSign: MARKET_CONTRACT_SIGN_ROUTES,
  marketContractTerminate: MARKET_CONTRACT_TERMINATE_ROUTES,
  marketContractWithdrawTermination: MARKET_CONTRACT_WITHDRAW_TERMINATION_ROUTES,
  education: EDUCATION_ROUTES,
  educationDetails: EDUCATION_DETAILS_ROUTES,
  employerUser: EMPLOYER_USER_ROUTES,
  employment: EMPLOYMENT_ROUTES,
  employerFacility: EMPLOYER_FACILITY_ROUTES,
  employerInfo: EMPLOYER_INFO_CURRENT_ROUTES,
  facilities: FACILITY_ROUTES,
  publicFacilities: {
    get: '/facilities/public-search',
  },
  institutions: INSTITUTIONS_ROUTES,
  jobListing: JOB_LISTING_ROUTES,
  jobListingActive: JOB_LISTING_ACTIVE_ROUTES,
  jobListingActivate: JOB_LISTING_ACTIVATE_ROUTES,
  jobListingDeactivate: JOB_LISTING_DEACTIVATE_ROUTES,
  jobFitSearchScores: { get: '/job-fit/search-scores' },
  b2bFitSearchScores: { get: '/b2b/fit/search-scores' },
  jobListingMarketplaceSearch: JOB_LISTING_MARKETPLACE_SEARCH_ROUTES,
  jobListingFacilities: JOB_LISTING_FACILITIES_ROUTES,
  jobListingDetails: JOB_LISTING_DETAILS_ROUTES,
  jobListingSummary: JOB_LISTING_SUMMARY_ROUTES,
  jobListingCostCalculator: JOB_LISTING_CALCULATIONS_ROUTES,
  jobListingStates: JOB_LISTING_STATES_ROUTES,
  jobResponses: JOB_RESPONSE_ROUTES,
  jobResponseBeginNegotiation: JOB_RESPONSE_BEGIN_NEGOTIATION_ROUTES,
  jobResponseInitialMessage: JOB_RESPONSE_INITIAL_MESSAGE_ROUTES,
  jobResponseNegotiationDraft: JOB_RESPONSE_NEGOTIATION_DRAFT_ROUTES,
  jobResponseInitialNegotiation: JOB_RESPONSE_INITIAL_NEGOTIATION_ROUTES,
  jobMessages: JOB_MESSAGES_ROUTES,
  jobMessagesRead: JOB_MESSAGES_READ_ROUTES,
  serviceOpportunities: SERVICE_OPPORTUNITIES_ROUTES,
  serviceOpportunity: SERVICE_OPPORTUNITY_ROUTES,
  serviceOpportunityCounter: SERVICE_OPPORTUNITY_COUNTER_ROUTES,
  serviceOpportunityCounterAvailability: SERVICE_OPPORTUNITY_COUNTER_AVAILABILITY_ROUTES,
  jobOpportunities: JOB_OPPORTUNITIES_ROUTES,
  jobOpportunityStatus: JOB_OPPORTUNITY_STATUS_ROUTES,
  geographySearch: GEOGRAPHY_SEARCH_ROUTES,
  providerServiceListings: PROVIDER_SERVICE_LISTING_ROUTES,
  providerServiceListing: PROVIDER_SERVICE_LISTING_DETAIL_ROUTES,
  providerServiceListingSearch: PROVIDER_SERVICE_LISTING_SEARCH_ROUTES,
  providerCalendar: PROVIDER_CALENDAR_ROUTES,
  providerCalendarBulk: PROVIDER_CALENDAR_BULK_ROUTES,
  providerCalendarContracts: PROVIDER_CALENDAR_CONTRACTS_ROUTES,
  providerCalendarDay: PROVIDER_CALENDAR_DAY_ROUTES,
  providerCalendarBatchReplace: PROVIDER_CALENDAR_BATCH_REPLACE_ROUTES,
  providerCalendarRules: PROVIDER_CALENDAR_RULES_ROUTES,
  providerCalendarRule: PROVIDER_CALENDAR_RULE_ROUTES,
  providerCalendarRuleExceptions: PROVIDER_CALENDAR_RULE_EXCEPTION_ROUTES,
  providerServiceListingActivate: PROVIDER_SERVICE_LISTING_ACTIVATE_ROUTES,
  providerServiceListingArchive: PROVIDER_SERVICE_LISTING_ARCHIVE_ROUTES,
  providerServiceListingPause: PROVIDER_SERVICE_LISTING_PAUSE_ROUTES,
  providerServiceLicenseStateSuggestions: PROVIDER_SERVICE_LICENSE_STATE_SUGGESTIONS_ROUTES,
  b2bJobOpportunities: B2B_JOB_OPPORTUNITIES_ROUTES,
  b2bListingResponses: B2B_LISTING_RESPONSES_ROUTES,
  providerJobResponses: PROVIDER_JOB_RESPONSES_ROUTES,
  jobResponseViewed: JOB_RESPONSE_VIEWED_ROUTES,
  jobNegotiationByResponse: JOB_NEGOTIATION_BY_RESPONSE_ROUTES,
  jobNegotiations: JOB_NEGOTIATIONS_ROUTES,
  jobNegotiationCalculations: JOB_NEGOTIATION_CALCULATIONS_ROUTES,
  jobResponseProviders: JOB_RESPONSE_PROVIDERS_ROUTES,
  hlxPickerProviders: HLX_PICKER_PROVIDERS_ROUTES,
  malpracticeInsurance: INSURANCE_ROUTES,
  medicalBoards: MEDICAL_BOARD_ROUTES,
  medicalLicenses: MEDICAL_LICENSES_ROUTES,
  medicalLicenseTypes: MEDICAL_LICENSE_TYPES_ROUTE,
  hlxCalendarEvents: HLX_CALENDAR_EVENTS_ROUTES,
  msaasListing: MSAAS_LISTING_ROUTES,
  msaasListingSearch: MSAAS_LISTING_SEARCH_ROUTES,
  msaasListingFitCheck: MSAAS_LISTING_FIT_CHECK_ROUTES,
  msaasListingFacilities: MSAAS_FACILITIES_ROUTES,
  msaasListingActivate: MSAAS_LISTING_ACTIVATE_ROUTES,
  msaasListingDeactivate: MSAAS_LISTING_DEACTIVATE_ROUTES,
  msaasListingCancel: MSAAS_LISTING_CANCEL_ROUTES,
  msaasListingRelist: MSAAS_LISTING_RELIST_ROUTES,
  msaasListingGeographies: MSAAS_GEOGRAPHIES_ROUTES,
  msaasListingProviders: MSAAS_PROVIDERS_ROUTES,
  msaasNegotiation: NEGOTIATION_ROUTES,
  msaasNegotiations: NEGOTIATIONS_ROUTES,
  msaasNegotiationsByEmployer: MSAAS_NEGOTIATIONS_BY_EMPLOYER_ROUTES,
  msaasNegotiationByResponse: MSAAS_NEGOTIATION_BY_RESPONSE_ROUTES,
  msaasNegotiationCalculations: MSAAS_NEGOTIATION_CALCULATIONS_ROUTES,
  msaasNegotiationContractSummary: MSAAS_NEGOTIATION_CONTRACT_SUMMARY_ROUTES,
  msaasNegotiationShiftBreakdown: MSAAS_NEGOTIATION_SHIFT_BREAKDOWN_ROUTES,
  msaasDetails: MSAAS_DETAILS_ROUTES,
  msaasDetailSummary: MSAAS_DETAIL_SUMMARY_ROUTES,
  msaasCostCalculator: MSAAS_DETAIL_CALCULATIONS_ROUTES,
  msaasListingStates: MSAAS_STATES_ROUTES,
  notifications: NOTIFICATION_ROUTES,
  notificationsReadAll: NOTIFICATION_READ_ALL_ROUTES,
  privileges: PRIVILEGES_ROUTES,
  privilegesBulkActions: BULK_PRIVILEGES_ROUTES,
  privilegesDownload: EXPORT_PRIVILEGES_ROUTES,
  provider: PROVIDER_ROUTES,
  providerCategories: PROVIDER_CATEGORIES_ROUTE,
  providerDetails: PROVIDER_DETAILS_ROUTE,
  profileSuggestions: PROFILE_SUGGESTIONS_ROUTES,
  vaultNewRecords: VAULT_NEW_RECORDS_ROUTES,
  providerTypes: PROVIDER_TYPES_ROUTE,
  allProviderTypes: ALL_PROVIDER_TYPES_ROUTE,
  providerPeerReference: PROVIDER_PEER_REFERENCE_ROUTES,
  peerReference: PEER_REFERENCE_ROUTES,
  peerReferencesRequest: PEER_REFERENCE_REQ_ROUTES,
  peerReferencesRequestResend: PEER_REFERENCE_REQ_RESEND_ROUTES,
  training: TRAINING_ROUTES,
  specialtyBoards: SPECIALTY_BOARD_ROUTES,
  specialties: SPECIALTY_ROUTES,
  specialtyCertRoutes: SPECIALTY_CERT_ROUTES,
  specialtyCertBySpecialty: SPECIALTY_CERT_BY_SPECIALTY_ROUTES,
  subSpecialtyCertRoutes: SUB_SPECIALTY_CERTIFICATE_ROUTES,
  subSpecialtyCertByParent: SUB_SPECIALTY_CERT_BY_PARENT_ROUTES,
  providerAssociations: PROVIDER_ASSOCIATION_ROUTES,
  providerAssociationHistory: PROVIDER_ASSOCIATION_HISTORY_ROUTES,
  providerAssociationProviderHistory: PROVIDER_ASSOCIATION_PROVIDER_HISTORY_ROUTES,
  providerAssociationInvitations: PROVIDER_ASSOCIATION_INVITATIONS_ROUTES,
  providerAssociationInvitationResend: PROVIDER_ASSOCIATION_INVITATION_RESEND_ROUTES,
  providerAssociationInvite: PROVIDER_ASSOCIATION_INVITE_ROUTES,
  providerLookupByNpi: PROVIDER_ASSOCIATION_LOOKUP_BY_NPI_ROUTES,
  providerAddManaged: PROVIDER_ASSOCIATION_ADD_MANAGED_ROUTES,
  providerInviteManaged: PROVIDER_ASSOCIATION_INVITE_MANAGED_ROUTES,
  providerAssociationVerify: PROVIDER_ASSOCIATION_VERIFY_ROUTES,
  providerAssociationRecipient: PROVIDER_ASSOCIATION_RECIPIENT_ROUTES,
  providerAssociationAccept: PROVIDER_ASSOCIATION_ACCEPT_ROUTES,
  providerAssociationCurrent: PROVIDER_ASSOCIATION_CURRENT_ROUTES,
  providerAssociationDisassociate: PROVIDER_ASSOCIATION_DISASSOCIATE_ROUTES,
  employerUserInvitationVerify: EMPLOYER_USER_INVITATION_VERIFY_ROUTES,
  employerUserInvitationEligibility: EMPLOYER_USER_INVITATION_ELIGIBILITY_ROUTES,
  employerUserFromInvitation: EMPLOYER_USER_FROM_INVITATION_ROUTES,
  employerUserInvitationsForEmployer: EMPLOYER_USER_INVITATIONS_FOR_EMPLOYER_ROUTES,
  employerUserInvitationResend: EMPLOYER_USER_INVITATION_RESEND_ROUTES,
  billingSummary: BILLING_ROUTES.summary,
  billingHistory: BILLING_ROUTES.history,
  billingSchedules: BILLING_ROUTES.schedules,
  billingPortalSession: BILLING_ROUTES.portalSession,
  billingActivationPreview: BILLING_ROUTES.activationPreview,
  billingListingActivationPreview: BILLING_ROUTES.listingActivationPreview,
  billingAdminCredits: BILLING_ROUTES.adminCredits,
  billingAdminCredit: BILLING_ROUTES.adminCredit,
  user: USER_ROUTES,
  newEmployerUserRegistration: {
    post: '/employer-users/new-registration',
  },
  currentProvider: {
    get: '/providers/for_current_user',
  },
  userRole: {
    get: '/user-roles/for_current_user/summary',
    post: '/user-roles',
  },
  userInfo: {
    get: '/user-info',
  },
  userInfoDeactivate: {
    post: '/user-info/deactivate',
  },
  userInfoSyncEmail: {
    post: '/user-info/sync-primary-email',
  },
  supportRequest: {
    post: '/support-requests',
  },
  hlxProviderView: HLX_PROVIDER_VIEW_ROUTES,
  hlxProviderViewByResponseProvider: HLX_PROVIDER_VIEW_BY_RESPONSE_PROVIDER_ROUTES,
  hlxProviderViewByServiceListing: HLX_PROVIDER_VIEW_BY_SERVICE_LISTING_ROUTES,
  hlxUnmaskRequest: HLX_UNMASK_REQUEST_ROUTES,
  hlxUnmaskApprove: HLX_UNMASK_APPROVE_ROUTES,
  hlxUnmaskReject: HLX_UNMASK_REJECT_ROUTES,
  hlxJobResponseUnmaskRequest: HLX_JOB_RESPONSE_UNMASK_REQUEST_ROUTES,
  hlxJobResponseUnmaskState: HLX_JOB_RESPONSE_UNMASK_STATE_ROUTES,
  hlxJobResponseUnmaskApprove: HLX_JOB_RESPONSE_UNMASK_APPROVE_ROUTES,
  hlxJobResponseUnmaskReject: HLX_JOB_RESPONSE_UNMASK_REJECT_ROUTES,
  hlxJobResponseUnmaskWithdraw: HLX_JOB_RESPONSE_UNMASK_WITHDRAW_ROUTES,
  hlxAccept: HLX_ACCEPT_ROUTES,
  hlxAcceptListing: HLX_ACCEPT_LISTING_ROUTES,
};
